var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _JwtBearerAuth_instances, _JwtBearerAuth_type, _JwtBearerAuth_env, _JwtBearerAuth_sdk, _JwtBearerAuth_assertSIWE, _JwtBearerAuth_assertSRP;
import { SIWEJwtBearerAuth } from "./authentication-jwt-bearer/flow-siwe.mjs";
import { SRPJwtBearerAuth } from "./authentication-jwt-bearer/flow-srp.mjs";
import { getNonce, pairIdentifiers } from "./authentication-jwt-bearer/services.mjs";
import { AuthType } from "./authentication-jwt-bearer/types.mjs";
import { PairError, UnsupportedAuthTypeError } from "./errors.mjs";
export class JwtBearerAuth {
    constructor(...args) {
        _JwtBearerAuth_instances.add(this);
        _JwtBearerAuth_type.set(this, void 0);
        _JwtBearerAuth_env.set(this, void 0);
        _JwtBearerAuth_sdk.set(this, void 0);
        __classPrivateFieldSet(this, _JwtBearerAuth_type, args[0].type, "f");
        __classPrivateFieldSet(this, _JwtBearerAuth_env, args[0].env, "f");
        if (args[0].type === AuthType.SRP) {
            __classPrivateFieldSet(this, _JwtBearerAuth_sdk, new SRPJwtBearerAuth(args[0], args[1]), "f");
            return;
        }
        if (args[0].type === AuthType.SiWE) {
            __classPrivateFieldSet(this, _JwtBearerAuth_sdk, new SIWEJwtBearerAuth(args[0], args[1]), "f");
            return;
        }
        throw new UnsupportedAuthTypeError('unsupported auth type');
    }
    setCustomProvider(provider) {
        __classPrivateFieldGet(this, _JwtBearerAuth_instances, "m", _JwtBearerAuth_assertSRP).call(this, __classPrivateFieldGet(this, _JwtBearerAuth_type, "f"), __classPrivateFieldGet(this, _JwtBearerAuth_sdk, "f"));
        __classPrivateFieldGet(this, _JwtBearerAuth_sdk, "f").setCustomProvider(provider);
    }
    async getAccessToken() {
        return await __classPrivateFieldGet(this, _JwtBearerAuth_sdk, "f").getAccessToken();
    }
    async connectSnap() {
        __classPrivateFieldGet(this, _JwtBearerAuth_instances, "m", _JwtBearerAuth_assertSRP).call(this, __classPrivateFieldGet(this, _JwtBearerAuth_type, "f"), __classPrivateFieldGet(this, _JwtBearerAuth_sdk, "f"));
        return __classPrivateFieldGet(this, _JwtBearerAuth_sdk, "f").connectSnap();
    }
    async isSnapConnected() {
        __classPrivateFieldGet(this, _JwtBearerAuth_instances, "m", _JwtBearerAuth_assertSRP).call(this, __classPrivateFieldGet(this, _JwtBearerAuth_type, "f"), __classPrivateFieldGet(this, _JwtBearerAuth_sdk, "f"));
        return __classPrivateFieldGet(this, _JwtBearerAuth_sdk, "f").isSnapConnected();
    }
    async getUserProfile() {
        return await __classPrivateFieldGet(this, _JwtBearerAuth_sdk, "f").getUserProfile();
    }
    async getIdentifier() {
        return await __classPrivateFieldGet(this, _JwtBearerAuth_sdk, "f").getIdentifier();
    }
    async signMessage(message) {
        return await __classPrivateFieldGet(this, _JwtBearerAuth_sdk, "f").signMessage(message);
    }
    async pairIdentifiers(pairing) {
        const profile = await this.getUserProfile();
        const n = await getNonce(profile.profileId, __classPrivateFieldGet(this, _JwtBearerAuth_env, "f"));
        const logins = await Promise.all(pairing.map(async (p) => {
            try {
                const raw = `metamask:${n.nonce}:${p.identifier}`;
                const sig = await p.signMessage(raw);
                return {
                    signature: sig,
                    // TODO: Either fix this lint violation or explain why it's necessary to ignore.
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    raw_message: raw,
                    // TODO: Either fix this lint violation or explain why it's necessary to ignore.
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    encrypted_storage_key: p.encryptedStorageKey,
                    // TODO: Either fix this lint violation or explain why it's necessary to ignore.
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    identifier_type: p.identifierType,
                };
            }
            catch (e) {
                /* istanbul ignore next */
                const errorMessage = e instanceof Error ? e.message : JSON.stringify(e ?? '');
                throw new PairError(`failed to sign pairing message: ${errorMessage}`);
            }
        }));
        const accessToken = await this.getAccessToken();
        await pairIdentifiers(n.nonce, logins, accessToken, __classPrivateFieldGet(this, _JwtBearerAuth_env, "f"));
    }
    prepare(signer) {
        __classPrivateFieldGet(this, _JwtBearerAuth_instances, "m", _JwtBearerAuth_assertSIWE).call(this, __classPrivateFieldGet(this, _JwtBearerAuth_type, "f"), __classPrivateFieldGet(this, _JwtBearerAuth_sdk, "f"));
        __classPrivateFieldGet(this, _JwtBearerAuth_sdk, "f").prepare(signer);
    }
}
_JwtBearerAuth_type = new WeakMap(), _JwtBearerAuth_env = new WeakMap(), _JwtBearerAuth_sdk = new WeakMap(), _JwtBearerAuth_instances = new WeakSet(), _JwtBearerAuth_assertSIWE = function _JwtBearerAuth_assertSIWE(type, _sdk) {
    if (type === AuthType.SiWE) {
        return;
    }
    throw new UnsupportedAuthTypeError('This method is only available via SIWE auth type');
}, _JwtBearerAuth_assertSRP = function _JwtBearerAuth_assertSRP(type, _sdk) {
    if (type === AuthType.SRP) {
        return;
    }
    throw new UnsupportedAuthTypeError('This method is only available via SRP auth type');
};
export { SIWEJwtBearerAuth } from "./authentication-jwt-bearer/flow-siwe.mjs";
export { SRPJwtBearerAuth } from "./authentication-jwt-bearer/flow-srp.mjs";
export * from "./authentication-jwt-bearer/types.mjs";
//# sourceMappingURL=authentication.mjs.map